<template>
    <div>
        <div class="desc">抱歉，你访问的页面不存在</div>
        <router-link :to="{path:'/login'}">
            <el-button type="primary">返回首页</el-button>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "notFound"
    }
</script>

<style scoped lang="scss">
    .desc{
        margin-top: 40px;
        font-size: 20px;
        color: white;
        text-align: center;
    }
</style>